module.exports = __webpack_public_path__ + "static/media/itkintertractionelectrics.be32fffb.png";